import { StorageInfoResponse } from '../../api/fetchStorageInfo';
import {
    CalculatorsConfig,
    GenieMemoryConfig,
    GeniePadElementsSettingItem,
    GenieSettings,
    IClaimableAmount,
    MessageConfigType,
    VitalsConfig,
} from '../../api/pushGenie';
import { GDyForm, SectionNameConfig } from '../db';
import { GlobalState } from '../reducers';
import { CareCanvas } from '../types/CareCanvas';
import { MHC } from '../types/medicalHistory';
import { Patient } from '../types/patient';

export const getIsPreviewDirty = (state: GlobalState): boolean => state.session.isPreviewDirty;

export const getIsPrivacyDialogVisible = (state: GlobalState): boolean =>
    state.session.privacyDialogVisible;
export const getIsGoogleReviewDialogVisible = (state: GlobalState): string | undefined =>
    state.session.googleReviewDialogVisible;
export const getShowEkaCommDialogVisible = (state: GlobalState): boolean =>
    state.session.showEkaCommunications;

export const getIsGlobalSearchVisible = (state: GlobalState): boolean =>
    state.session.isGlobalSearchVisible;
export const getIsStorageVisible = (state: GlobalState): boolean =>
    state.session.isStorageModalVisible;
export const getIsStorageInfo = (state: GlobalState): StorageInfoResponse | undefined =>
    state.session.storageInfo;

export const getIFrameDialogUrl = (state: GlobalState): string | undefined =>
    state.session.iframeDialogUrl;

export const getRefreshPage = (state: GlobalState): boolean | undefined =>
    state.session.refreshPage;

export const getEditPatient = (state: GlobalState): Patient | undefined =>
    state.session.editPatient;

export const getEditPtMH = (state: GlobalState): MHC | undefined => state.session.ptMedicalHistory;

export const getVitalsPadConfig = (state: GlobalState): VitalsConfig | undefined =>
    state.session?.padConfig?.vitalsPadConfig;

export const getCalcultorPadConfig = (state: GlobalState): CalculatorsConfig | undefined =>
    state.session?.padConfig?.calculatorPadConfig;

export const getSectionNameConfig = (state: GlobalState): SectionNameConfig | undefined =>
    state.session?.padConfig?.sectionNameConfig;

export const getPadDyForm = (state: GlobalState): GDyForm[] | undefined =>
    state.session?.padConfig?.dyForm;

export const getIsSettingUp = (state: GlobalState): boolean => state.session.isSettingUp;

export const getKhataCredits = (state: GlobalState): number | undefined =>
    state.session.khataCredits;

export const getPincode = (state: GlobalState): string | undefined => state.session.pincode;

export const getAbhaPotentialLoss = (state: GlobalState): number | undefined =>
    state.session.abhaPotentialLoss;

export const getClaimableAmount = (state: GlobalState): IClaimableAmount[] | undefined =>
    state.session.claimableAmount;

export const getMonthlyAbhaLoss = (state: GlobalState): number | undefined =>
    state.session.currentMonthLoss;

export const getIsFollowupAutoFillEnabled = (state: GlobalState): boolean =>
    (getGenieSetting(state, 'autoFillFollowUp') as boolean) || false;

export const getIsSmartSuggestions = (state: GlobalState): boolean | undefined =>
    getGenieSetting(state, 'smartSuggestions') as boolean | undefined;

export const getIsVaccinationChartVisible = (state: GlobalState): boolean | undefined =>
    getGenieSetting(state, 'showVaccinationChart') as boolean | undefined;

export const getIsICDSuggestionsEnabled = (state: GlobalState): boolean | undefined =>
    getGenieSetting(state, 'icdSuggestion') as boolean | undefined;

export const getIsGrowthChartSuggestionsEnabled = (state: GlobalState): boolean | undefined =>
    getGenieSetting(state, 'growthChart') as boolean | undefined;

export const getIsMilestoneEnabled = (state: GlobalState): boolean | undefined =>
    getGenieSetting(state, 'showMilestone') as boolean | undefined;

export const getPxElementConfig = (state: GlobalState): GeniePadElementsSettingItem[] =>
    getGenieSetting(state, 'padElements') as GeniePadElementsSettingItem[];

export const getMedTypeIds = (state: GlobalState): string[] =>
    getGenieSetting(state, 'medTypeIds') as string[];

export const getGenieSetting = (
    state: GlobalState,
    key: keyof GenieSettings,
): boolean | string[] | GeniePadElementsSettingItem[] | MessageConfigType[] | GenieMemoryConfig =>
    state.session[key];

export const getActiveOrderUpdatesCount = (state: GlobalState): number | undefined =>
    state.session.activeOrderUpdatesCount;

export const getDontAllowStartVisit = (state: GlobalState): boolean => {
    const { dontAllowStartVisit } = state.session;
    return !!dontAllowStartVisit;
};

export const getIsNotesMode = (state: GlobalState): boolean => {
    const { isNotesMode } = state.session;
    return !!isNotesMode;
};

export const getIsTreatmentPlanEnabled = (state: GlobalState): boolean | undefined =>
    state.session.isTreatmentPlanEnabled;

export const getIsDicomEnabled = (state: GlobalState): boolean | undefined =>
    state.session.isDicomEnabled;

export const getAdmissionToIPDEnabled = (state: GlobalState): boolean | undefined =>
    getGenieSetting(state, 'admissionToIPDEnabled') as boolean | undefined;

export const getCareCanvasPreview = (state: GlobalState): CareCanvas | undefined =>
    state.session.careCanvasPreview;

export const getIsLogoutModalVisible = (state: GlobalState): boolean | undefined =>
    state.session.showLogoutModal;

export const getBusinessUhidPrefix = (state: GlobalState): string | undefined =>
    state.session.businessUhidPrefix;

export const getGlobalSearchFlag = (state: GlobalState): boolean | undefined =>
    state.session.enableBEGlobalSearch;

export const getMedRouteEnabled = (state: GlobalState): boolean | undefined =>
    getGenieSetting(state, 'medRouteEnabled') as boolean | undefined;
